import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';

import { environment } from '../../environments/environment';
import { Models } from '../models/global.models';
import { REQUIRES_SECURITY_PROFILE } from '../interceptors';
import { catchError, of } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NavbarService {
  private readonly _http = inject(HttpClient);

  executeGlobalSearch = (searchTerm: string, showAll: boolean, maxSearchResultsPerType = 5) => {
    return this._http
      .get<Models.GlobalSearch>(`${environment.retail.apiUrl}/search?searchQuery=${searchTerm}${showAll ? '' : `&topN=${maxSearchResultsPerType}`}`, {
        context: new HttpContext().set(REQUIRES_SECURITY_PROFILE, true),
      })
      .pipe(
        catchError(() => {
          return of(null);
        }),
      );
  };
}
